<!-- Centred modal for hosts with nothing to anchor to (an Action Today card); the lead page banner
     renders the same form inline inside its own popover under the button (`asDialog` false). -->
<p-dialog
  *ngIf="asDialog"
  [visible]="visible"
  [modal]="true"
  [showHeader]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="noHeader"
  [style]="{ width: '380px', maxWidth: '92vw' }"
  [baseZIndex]="100001"
  (onHide)="close()">
  <ng-container *ngTemplateOutlet="formTpl"></ng-container>
</p-dialog>

<ng-container *ngIf="!asDialog">
  <ng-container *ngTemplateOutlet="formTpl"></ng-container>
</ng-container>

<ng-template #formTpl>
  <div class="close-lead">
    <div class="close-lead__head">
      <h3 class="close-lead__title">Move to No Further Interest</h3>
      <button type="button" class="close-lead__x" aria-label="Close" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <p class="close-lead__text">
      <ng-container *ngIf="message">{{ message }}<br /></ng-container>
      Please confirm the reason for closing <ng-container *ngIf="leadName; else thisLead">{{ leadName }}</ng-container
      ><ng-template #thisLead>this lead</ng-template>.
    </p>

    <div class="close-lead__field">
      <label for="close_lead_reason">Closure Reason <span class="close-lead__required">*</span></label>
      <ng-select
        id="close_lead_reason"
        [items]="reasons"
        [searchable]="true"
        [clearable]="false"
        placeholder="Select a reason"
        [appendTo]="asDialog ? 'body' : null"
        [(ngModel)]="reason"
        [ngModelOptions]="{ standalone: true }"
        [ngClass]="{ '_input-error': isSubmitted && !reason }">
        <ng-template ng-option-tmp let-item="item">
          <div [title]="item">{{ item }}</div>
        </ng-template>
      </ng-select>
    </div>

    <div class="close-lead__field">
      <label for="close_lead_note">Notes <span class="close-lead__optional">(optional)</span></label>
      <textarea
        pInputTextarea
        id="close_lead_note"
        class="close-lead__note"
        placeholder="Add notes (optional)..."
        [maxlength]="noteMaxLength"
        [(ngModel)]="note"
        [ngModelOptions]="{ standalone: true }"></textarea>
      <span class="close-lead__count">{{ note?.length || 0 }}/{{ noteMaxLength }}</span>
    </div>

    <div class="close-lead__actions">
      <button type="button" class="_cancel-btn" [disabled]="isSaving" (click)="close()">Cancel</button>
      <button type="button" class="_danger-btn" [disabled]="isSaving" (click)="save()">
        <i class="pi pi-spin pi-spinner mr-1" *ngIf="isSaving"></i>
        Move to No Further Interest
      </button>
    </div>
  </div>
</ng-template>
